import { trackClicked } from '#/utils/analytics/track/trackClicked';

import {
  PageFooterCentralLink,
  PageFooterCentralLinksHolder,
} from './PageFooterCentralLinks.styled';

const links = [
  {
    title: 'Terms',
    href: '/en/terms-of-service',
    trackClickedName: 'Terms Of Service',
  },
  {
    type: 'privacy-policy',
    title: 'Privacy Policy',
    href: '/en/privacy-policy',
    trackClickedName: 'Privacy Policy',
  },
  {
    title: 'Site Map',
    href: '/en/sitemap',
    trackClickedName: 'Site Map',
  },
];

export function PageFooterCentralLinks() {
  return (
    <PageFooterCentralLinksHolder>
      {links.map((link) => (
        <PageFooterCentralLink
          key={link.title}
          to={link.href}
          onClick={() => {
            trackClicked(link.trackClickedName, { context: 'Footer' });
          }}
        >
          {link.title}
        </PageFooterCentralLink>
      ))}
    </PageFooterCentralLinksHolder>
  );
}
